import React from "react";
import {
    FaBolt,
    FaShieldAlt,
    FaMagic,
    FaRocket,
    FaApple,
    FaLaptopCode
} from "react-icons/fa";

const BenefitsSwift = () => {

    const benefits = [
        {
            number: "01",
            title: "Native iOS Performance",
            desc: "Swift delivers ultra-fast native performance for premium Apple applications.",
            icon: <FaBolt />,
        },
        {
            number: "02",
            title: "Secure Architecture",
            desc: "Advanced type safety and memory management create highly secure apps.",
            icon: <FaShieldAlt />,
        },
        {
            number: "03",
            title: "Modern UI Experience",
            desc: "Build elegant, fluid and smooth interfaces for Apple devices.",
            icon: <FaMagic />,
        },
        {
            number: "04",
            title: "Scalable Applications",
            desc: "Perfect for startup MVPs and enterprise-grade iOS ecosystems.",
            icon: <FaRocket />,
        },
        {
            number: "05",
            title: "Apple Ecosystem Support",
            desc: "Seamless integration with iPhone, iPad, WatchOS and macOS.",
            icon: <FaApple />,
        },
        {
            number: "06",
            title: "Faster Development",
            desc: "Swift simplifies development workflows with clean and modern syntax.",
            icon: <FaLaptopCode />,
        },
    ];

    return (
        <>
            <section className="swift-benefits">

                {/* BACKGROUND */}
                <div className="sb-grid"></div>

                <div className="sb-glow glow1"></div>
                <div className="sb-glow glow2"></div>

                <div className="sb-container">

                    {/* TOP */}
                    <div className="sb-top">

                        <div className="sb-badge">
                            🍎 Swift Benefits
                        </div>

                        <h2>
                            Benefits of
                            <span> Swift</span>
                        </h2>

                        <p>
                            Swift empowers businesses with high-performance,
                            scalable and secure iOS applications designed
                            for the Apple ecosystem.
                        </p>

                    </div>

                    {/* BENEFITS */}
                    <div className="sb-layout">

                        {benefits.map((item, i) => (

                            <div
                                className={`sb-card sb-card-${i + 1}`}
                                key={i}
                            >

                                <div className="sb-number">
                                    {item.number}
                                </div>

                                <div className="sb-icon">
                                    {item.icon}
                                </div>

                                <h3>
                                    {item.title}
                                </h3>

                                <p>
                                    {item.desc}
                                </p>

                                <div className="sb-hover"></div>

                            </div>

                        ))}

                        {/* CENTER CIRCLE */}
                        <div className="sb-center">

                            <div className="sb-ring ring1"></div>
                            <div className="sb-ring ring2"></div>

                            <div className="sb-core">
                                🍎
                            </div>

                        </div>

                    </div>

                </div>

                <style>{`

                .swift-benefits{
                    position:relative;
                    overflow:hidden;
                    padding:150px 24px;
                    background:
                    linear-gradient(
                        180deg,
                        #ffffff 0%,
                        #fff5f5 50%,
                        #ffffff 100%
                    );
                }

                .sb-container{
                    max-width:1450px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                /* TOP */

                .sb-top{
                    text-align:center;
                    margin-bottom:120px;
                }

                .sb-badge{
                    display:inline-flex;
                    align-items:center;
                    gap:10px;

                    padding:12px 24px;

                    border-radius:999px;

                    background:rgba(232,33,42,.08);

                    border:1px solid rgba(232,33,42,.14);

                    color:#E8212A;

                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;

                    margin-bottom:30px;

                    animation:badgePulse 3s infinite;

                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .sb-top h2{
                    font-size:clamp(35px,7vw,54px);
                    line-height:.95;
                    margin:0 0 24px;
                    color:#111;
     text-align: center;
                    letter-spacing:-4px;
                    font-family:'Syne',sans-serif;
                }

                .sb-top h2 span{
                    color:#E8212A;
                }

                .sb-top p{
                    max-width:760px;
                    margin:auto;
                    text-align: center;
                    color:#666;
                    line-height:1.9;
                    font-size:18px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                /* LAYOUT */

                .sb-layout{
                    position:relative;
                    height:1000px;
                }

                /* CENTER */

                .sb-center{
                    position:absolute;
                    left:50%;
                    top:50%;
                    transform:translate(-50%,-50%);
                    width:320px;
                    height:320px;

                    display:flex;
                    align-items:center;
                    justify-content:center;
                }

                .sb-ring{
                    position:absolute;
                    border-radius:50%;
                    border:1px dashed rgba(232,33,42,.18);

                    animation:ringRotate linear infinite;
                }

                .ring1{
                    width:360px;
                    height:360px;
                    animation-duration:20s;
                }

                .ring2{
                    width:520px;
                    height:520px;
                    animation-duration:30s;
                    animation-direction:reverse;
                }

                .sb-core{
                    width:180px;
                    height:180px;
                    border-radius:50%;

                    display:flex;
                    align-items:center;
                    justify-content:center;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    color:#fff;
                    font-size:74px;

                    box-shadow:
                    0 30px 90px rgba(232,33,42,.25);

                    animation:coreFloat 5s infinite ease-in-out;

                    position:relative;
                    z-index:2;
                }

                .sb-core::before{
                    content:"";
                    position:absolute;
                    inset:-25px;
                    border-radius:50%;
                    border:1px solid rgba(232,33,42,.15);
                    animation:pulseRing 3s infinite;
                }

                /* CARDS */

                .sb-card{
                    position:absolute;

                    width:320px;
                    min-height:260px;

                    padding:34px;

                    border-radius:34px;

                    background:#fff;

                    border:1px solid #f2f2f2;

                    box-shadow:
                    0 20px 60px rgba(0,0,0,.05);

                    overflow:hidden;

                    transition:.45s ease;

                    backdrop-filter:blur(10px);
                }

                .sb-card:hover{
                    transform:translateY(-14px) scale(1.03);

                    border-color:rgba(232,33,42,.18);

                    box-shadow:
                    0 35px 80px rgba(232,33,42,.14);
                }

                .sb-card::before{
                    content:"";
                    position:absolute;
                    inset:0;

                    background:
                    linear-gradient(
                        135deg,
                        rgba(232,33,42,.08),
                        transparent 60%
                    );

                    opacity:0;
                    transition:.45s ease;
                }

                .sb-card:hover::before{
                    opacity:1;
                }

                .sb-number{
                    position:absolute;
                    right:26px;
                    top:24px;

                    font-size:62px;
                    font-weight:900;

                    color:rgba(232,33,42,.08);

                    line-height:1;

                    font-family:'Syne',sans-serif;
                }

                .sb-icon{
                       width: 70px;
    height: 70px;

                    border-radius:26px;

                    display:flex;
                    align-items:center;
                    justify-content:center;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    color:#fff;
                        font-size: 36px;

                    margin-bottom:28px;

                    box-shadow:
                    0 18px 45px rgba(232,33,42,.2);

                    animation:floatIcon 4s infinite ease-in-out;
                }

                .sb-card h3{
                    color:#111;
                    font-size:25px;
                    line-height:1.15;
                    margin-bottom:16px;
                    letter-spacing:-1px;
                    font-family:'Syne',sans-serif;
                }

                .sb-card p{
                    color:#666;
                    line-height:1.8;
                    font-size:15px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .sb-hover{
                    position:absolute;
                    width:220px;
                    height:220px;
                    border-radius:50%;

                    background:
                    rgba(232,33,42,.12);

                    filter:blur(70px);

                    right:-80px;
                    bottom:-80px;

                    opacity:0;

                    transition:.5s ease;
                }

                .sb-card:hover .sb-hover{
                    opacity:1;
                }

                /* POSITION */

                .sb-card-1{
                    top:0;
                    left:60px;
                }

                .sb-card-2{
                    top:0;
                    right:60px;
                }

                .sb-card-3{
                    top:360px;
                    left:0;
                }

                .sb-card-4{
                    top:360px;
                    right:0;
                }

                .sb-card-5{
                    bottom:0;
                    left:120px;
                }

                .sb-card-6{
                    bottom:0;
                    right:120px;
                }

                /* GRID */

                .sb-grid{
                    position:absolute;
                    inset:0;

                    background-image:
                    linear-gradient(
                        rgba(0,0,0,.03) 1px,
                        transparent 1px
                    ),
                    linear-gradient(
                        90deg,
                        rgba(0,0,0,.03) 1px,
                        transparent 1px
                    );

                    background-size:70px 70px;

                    mask-image:
                    radial-gradient(
                        circle at center,
                        black,
                        transparent 90%
                    );
                }

                /* GLOW */

                .sb-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.14;
                }

                .glow1{
                    width:420px;
                    height:420px;
                    background:#E8212A;
                    left:-120px;
                    top:-120px;
                    animation:glowMove1 10s infinite ease-in-out;
                }

                .glow2{
                    width:380px;
                    height:380px;
                    background:#FF4D4D;
                    right:-100px;
                    bottom:-120px;
                    animation:glowMove2 12s infinite ease-in-out;
                }

                /* ANIMATION */

                @keyframes ringRotate{
                    from{
                        transform:rotate(0deg);
                    }
                    to{
                        transform:rotate(360deg);
                    }
                }

                @keyframes floatIcon{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-10px);
                    }
                }

                @keyframes badgePulse{
                    0%,100%{
                        transform:scale(1);
                    }
                    50%{
                        transform:scale(1.05);
                    }
                }

                @keyframes coreFloat{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-16px);
                    }
                }

                @keyframes pulseRing{
                    0%{
                        transform:scale(.9);
                        opacity:1;
                    }
                    100%{
                        transform:scale(1.2);
                        opacity:0;
                    }
                }

                @keyframes glowMove1{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(50px);
                    }
                }

                @keyframes glowMove2{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-50px);
                    }
                }

                /* RESPONSIVE */

                @media(max-width:1200px){

                    .sb-layout{
                        display:grid;
                        grid-template-columns:1fr 1fr;
                        gap:30px;
                        height:auto;
                    }

                    .sb-center{
                        position:relative;
                        left:auto;
                        top:auto;
                        transform:none;
                        margin:auto;
                        grid-column:span 2;
                        order:-1;
                    }

                    .sb-card{
                        position:relative !important;
                        top:auto !important;
                        left:auto !important;
                        right:auto !important;
                        bottom:auto !important;
                        width:100%;
                    }

                }

                @media(max-width:768px){

                    .swift-benefits{
                        padding:100px 18px;
                    }

                    .sb-layout{
                        grid-template-columns:1fr;
                    }

                    .sb-center{
                        grid-column:span 1;
                        width:260px;
                        height:260px;
                    }

                    .ring1{
                        width:260px;
                        height:260px;
                    }

                    .ring2{
                        width:360px;
                        height:360px;
                    }

                    .sb-core{
                        width:140px;
                        height:140px;
                        font-size:56px;
                    }

                    .sb-top h2{
                        letter-spacing:-2px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default BenefitsSwift;